module.exports = __webpack_public_path__ + "img/logo2.a8fbad92.png";